import { render, staticRenderFns } from "./list-context-reboquista.vue?vue&type=template&id=190afd6a&"
import script from "./list-context-reboquista.vue?vue&type=script&lang=js&"
export * from "./list-context-reboquista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports